import React from "react";
import "./SupportSection.css";

const SUPPORT_URL = "https://fairy.hada.io/@tooloves#support";

const messages = {
  ko: {
    label: "TOOLOVES SUPPORT",
    title: "TooLoves가 계속 운영될 수 있도록 도와주세요",
    body: "도메인이 30일 이내에 만료될 예정입니다. 후원금은 도메인 갱신과 서버 운영 비용에 사용되며, 충분히 모이지 않으면 서비스가 종료될 수 있습니다. 관심과 후원에 감사드립니다.",
    button: "후원하기",
  },
  en: {
    label: "TOOLOVES SUPPORT",
    title: "Help keep TooLoves online",
    body: "Our domain expires within 30 days. Donations will cover domain renewal and server costs. If we cannot raise enough, the service may close. Thank you for your support.",
    button: "Donate",
  },
  ja: {
    label: "TOOLOVES SUPPORT",
    title: "TooLovesの運営継続にご協力ください",
    body: "ドメインの有効期限が30日以内に迫っています。ご支援はドメインとサーバーの費用に使用します。十分な支援が集まらない場合、サービスを終了する可能性があります。ご関心とご支援に感謝いたします。",
    button: "支援する",
  },
  tw: {
    label: "TOOLOVES SUPPORT",
    title: "協助 TooLoves 持續營運",
    body: "網域將在30天內到期。贊助款將用於網域續費與伺服器費用。若未能籌得足夠款項，服務可能會停止營運。感謝您的關注與支持。",
    button: "前往贊助",
  },
};

function SupportSection({ locale = "ko" }) {
  const copy = messages[locale] || messages.ko;

  return (
    <section className="home-support-section" aria-labelledby={`support-title-${locale}`}>
      <div className="home-support-copy">
        <p className="home-support-label">{copy.label}</p>
        <h2 id={`support-title-${locale}`}>{copy.title}</h2>
        <p>{copy.body}</p>
      </div>
      <a
        className="home-support-button"
        href={SUPPORT_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span aria-hidden="true">♥</span>
        {copy.button}
      </a>
    </section>
  );
}

export default SupportSection;
